/**
 * How long the agent still has on a conversation. A mirror of the window rule
 * in functions/aiConversation/decideConversationAction.js, kept in step by
 * hand like SPEAKING_STATUS: from windowRestartedAt when the agent took the
 * lead back, from startedAt otherwise, for the agentConfig snapshot's
 * handoffWindowMinutes, extended while the person wrote in the last
 * ACTIVE_GRACE_MS.
 *
 * Past the deadline the scheduler hands the lead over on its next round, at
 * most two minutes later: hence "going back" rather than "gone back".
 */
const MINUTE = 60 * 1000;
export const ACTIVE_GRACE_MS = 5 * MINUTE;

const toMillis = (value) => (value instanceof Date ? value.getTime() : 0);

export const windowDeadline = (conversation) => {
  const from =
    toMillis(conversation.windowRestartedAt) ||
    toMillis(conversation.startedAt);
  const minutes = (conversation.agentConfig || {}).handoffWindowMinutes || 0;
  if (!from || !minutes) return null;
  return from + minutes * MINUTE;
};

/**
 * One of:
 * - `{ state: 'running', ms }`, the window is still open;
 * - `{ state: 'extended' }`, it is over but she is writing;
 * - `{ state: 'goingBack' }`, it is over and the next round hands her over;
 * - `{ state: 'unknown' }`, no start or no window to measure from.
 */
export const timeLeft = (conversation, now) => {
  const deadline = windowDeadline(conversation);
  if (!deadline) return { state: 'unknown' };

  const current = toMillis(now);
  if (current < deadline) return { state: 'running', ms: deadline - current };

  const last = toMillis(conversation.lastLeadMessageAt);
  if (last && current - last < ACTIVE_GRACE_MS) return { state: 'extended' };

  return { state: 'goingBack' };
};
